import {
  AddChangeRequestNumbersProps,
  AddProjectNumbersProps,
  CRLookUpForNumbers,
  CurrencyListInfo,
  ProjectNumbersInfo,
  UpdateProjectNumbers,
} from '../../../../../../types/ProjectManagement/Project/ProjectView/ProjectNumbers/ProjectNumbersTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../../../utils/apiUtils'
import {
  projectNumbersApiConfig,
  AllowedHttpMethods,
} from '../../../../apiList'

const getProjectNumbers = async (
  projectid: number,
): Promise<ProjectNumbersInfo> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectNumbersApiConfig.getProjectNumbers,
    method: AllowedHttpMethods.get,
    params: {
      projectid,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getCurrencyList = async (): Promise<CurrencyListInfo[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectNumbersApiConfig.getCurrencyList,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const projectNumbers = async (
  props: AddProjectNumbersProps,
): Promise<number | string> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectNumbersApiConfig.projectNumbers,
    method: AllowedHttpMethods.post,
    data: {
      currency: props.currency,
      poNumber: props.poNumber,
      projectAmount: props.projectAmount,
      projectId: props.projectId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const changeRequestNumbers = async (
  props: AddChangeRequestNumbersProps,
): Promise<number | string> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectNumbersApiConfig.changeRequestNumbers,
    method: AllowedHttpMethods.post,
    data: {
      changeRequestId: props.changeRequestId,
      currency: props.currency,
      description: props.description,
      hourlyRate: props.hourlyRate,
      poNumber: props.poNumber,
      projectAmount: props.projectAmount,
      projectId: props.projectId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getCRLookUpForNumbers = async (
  projectid: number,
): Promise<CRLookUpForNumbers[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectNumbersApiConfig.getCRLookUpForNumbers,
    method: AllowedHttpMethods.get,
    params: {
      projectid,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const updateProjectNumbers = async (
  props: UpdateProjectNumbers,
): Promise<number | string> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectNumbersApiConfig.updateProjectNumbers,
    method: AllowedHttpMethods.put,
    data: {
      changeRequestId: props.changeRequestId,
      crName: props.crName,
      crhours: props.crhours,
      currency: props.currency,
      description: props.description,
      hourlyRate: props.hourlyRate,
      id: props.id,
      poNumber: props.poNumber,
      projectAmount: props.projectAmount,
      projectId: props.projectId,
      projectname: props.projectname,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const updateCRNumbers = async (
  props: UpdateProjectNumbers,
): Promise<number | string> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectNumbersApiConfig.updateCRNumbers,
    method: AllowedHttpMethods.put,
    data: {
      changeRequestId: props.changeRequestId,
      crName: props.crName,
      crhours: props.crhours,
      currency: props.currency,
      description: props.description,
      hourlyRate: props.hourlyRate,
      id: props.id,
      poNumber: props.poNumber,
      projectAmount: props.projectAmount,
      projectId: props.projectId,
      projectname: props.projectname,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const ProjectNumbersApi = {
  getProjectNumbers,
  getCurrencyList,
  projectNumbers,
  getCRLookUpForNumbers,
  changeRequestNumbers,
  updateProjectNumbers,
  updateCRNumbers,
}
export default ProjectNumbersApi
